export const environment = {
  production: true,
  baseUrl: 'https://backend-prey.live.42-projects.com/api',
  imageUrl: 'https://backend-prey.live.42-projects.com/uploads/',
  clockifyUrl: 'https://api.clockify.me/api/v1',
  telemetryDeck: {
    enabled: true,
    appId: '96C75F50-9B74-42AB-96A7-68C414E075F7',
  },
  showTester: false,
};
